export default [
  {
    path: '/main/reportcomissions',
    meta: {
      tag: 'report_comissions',
      name: 'Relatório de Comissões',
      breadcrumb: 'Relatório de Comissões'
    },
    component: () => import(/* webpackChunkName: "report-comissions" */ '@/views/main/reports/comissions/Index.vue'),
    children: [
      {
        path: '',
        name: 'listcomissions',
        meta: {
          tag: 'report_comissions',
          name: 'Relatório de Comissões',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-comissions" */ '@/views/main/reports/comissions/List.vue'),
      }
    ]
  }
]